import React, { useMemo, useState } from "react";

export default function DeliveryTrendsChart({ routes = [] }) {
  const [filter, setFilter] = useState("delivered"); // delivered | failed | open | all

  // === Группируем заказы по дате и статусу ===
  const dailyStats = useMemo(() => {
    const map = {};
    routes.forEach((r) => {
      (r.receipts || []).forEach((rec) => {
        if (!rec.status_changed_at) return;
        const date = new Date(rec.status_changed_at)
          .toISOString()
          .split("T")[0];
        if (!map[date]) map[date] = { total: 0, delivered: 0, failed: 0, open: 0 };
        map[date].total++;
        if (rec.status === "Закрыта") map[date].delivered++;
        else if (rec.status === "Не доставлено") map[date].failed++;
        else if (rec.status === "Открыта") map[date].open++;
      });
    });

    const arr = Object.entries(map)
      .map(([date, val]) => ({
        date,
        ...val,
      }))
      .sort((a, b) => new Date(a.date) - new Date(b.date));

    return arr;
  }, [routes]);

  const maxVal = dailyStats.length
    ? Math.max(
        ...dailyStats.map((d) =>
          filter === "delivered"
            ? d.delivered
            : filter === "failed"
            ? d.failed
            : filter === "open"
            ? d.open
            : d.total
        )
      )
    : 0;

  // === Цвет для каждого фильтра ===
  const colorMap = {
    delivered: "#007bff",
    failed: "#e74c3c",
    open: "#f39c12",
    all: "#2ecc71",
  };

  const labelMap = {
    delivered: "доставлено",
    failed: "не доставлено",
    open: "открыто",
    all: "всего заказов",
  };

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: 16,
        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
      }}
    >
      <h3 style={{ marginTop: 0 }}>Динамика доставок</h3>
      <p style={{ color: "#666", marginBottom: 10 }}>
        Количество заказов по дням ({labelMap[filter]}).
      </p>

      {/* === Переключатели фильтра === */}
      <div style={{ display: "flex", gap: 6, marginBottom: 10, flexWrap: "wrap" }}>
        {[
          { key: "delivered", label: "Доставленные" },
          { key: "failed", label: "Недоставленные" },
          { key: "open", label: "Открытые" },
          { key: "all", label: "Все" },
        ].map((btn) => (
          <button
            key={btn.key}
            onClick={() => setFilter(btn.key)}
            style={{
              padding: "4px 10px",
              borderRadius: 6,
              border: "1px solid #ccc",
              background: filter === btn.key ? colorMap[btn.key] : "#fff",
              color: filter === btn.key ? "#fff" : "#000",
              fontSize: 13,
              cursor: "pointer",
              transition: "0.2s",
            }}
          >
            {btn.label}
          </button>
        ))}
      </div>

      {/* === График === */}
      {dailyStats.length === 0 ? (
        <p style={{ color: "#999" }}>Нет данных для отображения.</p>
      ) : (
        <div
          style={{
            height: 240,
            display: "flex",
            alignItems: "flex-end",
            gap: 6,
            borderBottom: "1px solid #eee",
            paddingBottom: 6,
            overflowX: "auto",
          }}
        >
          {dailyStats.map((d) => {
            const value =
              filter === "delivered"
                ? d.delivered
                : filter === "failed"
                ? d.failed
                : filter === "open"
                ? d.open
                : d.total;

            return (
              <div
                key={d.date}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: 36,
                  minWidth: 36,
                }}
              >
                <div
                  style={{
                    height: `${(value / (maxVal || 1)) * 180}px`,
                    width: "100%",
                    background: colorMap[filter],
                    borderRadius: 4,
                    transition: "height 0.3s",
                  }}
                  title={`Дата: ${d.date}\n${labelMap[filter]}: ${value}\nВсего: ${d.total}`}
                />
                <small
                  style={{
                    fontSize: 11,
                    color: "#555",
                    marginTop: 4,
                    whiteSpace: "nowrap",
                  }}
                >
                  {d.date.slice(5)}
                </small>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
